module.exports = __webpack_public_path__ + "static/media/hotel-villa-antonio-orebic-night-view.1bb92b9e.jpg";